import $ from "jquery";

class LangSelector {
    constructor($el) {
        this.$el = $el;

        if(this.$el.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.toggleMenuFn = this.toggleMenu.bind(this);

        this.$el.on('click', this.toggleMenuFn);
    }

    toggleMenu() {
        this.$el.toggleClass('language-selector--opened');
    }
}

export default LangSelector;
